"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.BadRequest = exports.TokenExpired = exports.InvalidJwtContent = exports.InvalidJwtEncoding = exports.InvalidTimezone = exports.IdentityProviderRejected = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../openapi");
const Auth = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Auth.Spec';
/**
 * The identity provider failure is passed through with status 422 whatever its code, so the
 * message is a plain code, not a fixed literal.
 */
exports.IdentityProviderRejected = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
            description: 'Code of the identity provider failure, such as INVALID_PASSWORD, EMAIL_NOT_FOUND, INVALID_EMAIL, USER_DISABLED, TOO_MANY_REQUESTS or NOT_ALLOWED. A code the API does not know is UNKNOWN_ERROR.',
        }),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.IdentityProviderRejected`,
    title: 'Identity Provider Rejected',
    description: 'The identity provider refused the sign-in. The status is 422 for every code, including the ones that sound like 404 or 429.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 422,
});
exports.InvalidTimezone = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidTimezone`, 'INVALID_TIMEZONE', 'Invalid Time Zone', 'The timezone is sent and is not a known time zone name.');
exports.InvalidJwtEncoding = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidJwtEncoding`, 'INVALID_JWT_ENCODING', 'Invalid JWT Encoding', 'The idToken cannot be decoded as a JWT.');
exports.InvalidJwtContent = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidJwtContent`, 'INVALID_JWT_CONTENT', 'Invalid JWT Content', 'The token lacks one of iss, aud, exp or sub, its issuer is not Apple or Google, or its audience is not one of the Culligan applications.');
exports.TokenExpired = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.TokenExpired`, 'TOKEN_EXPIRED', 'Token Expired', 'The exp claim of the idToken is in the past.');
/** The v1 `buildBadRequestResponse()` body: status 400 with the BAD_REQUEST code. */
exports.BadRequest = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({ message: effect_1.Schema.Literal('BAD_REQUEST') }),
}).annotations({
    identifier: `${exports.NAMESPACE}.BadRequest`,
    title: 'Bad Request',
    description: 'The handler could not make sense of the request path.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 400,
});
const verifyToken = platform_1.HttpApiEndpoint.get('verifyToken') `/login`
    .setUrlParams(Auth.VerifyQuery)
    .addSuccess(openapi_1.Response.Success(Auth.VerifyResult))
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(openapi_1.Error.V1LegacyValidation)
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .annotate(platform_1.OpenApi.Title, 'Verify Access Token')
    .annotate(platform_1.OpenApi.Description, 'Checks that the access token is valid; an invalid or expired token is rejected by the guard with 401. Without fastTokenVerification the handler loads the user profile and answers the user id. A token whose user has no profile in the database, which includes every CPort token, gets an empty success without the user id. When fastTokenVerification is sent with any accepted value (true, false, 1 or 0) the handler only tests that the parameter is present, so ?fastTokenVerification=false is a fast check too, and the answer is an empty success without the user id.')
    .pipe(openapi_1.Error.withV1StandardErrors);
const login = platform_1.HttpApiEndpoint.post('login') `/login`
    .setPayload(Auth.LoginPayload)
    .addSuccess(openapi_1.Response.Success(Auth.LoginResult))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.IdentityProviderRejected)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Sign In')
    .annotate(platform_1.OpenApi.Description, 'Signs a user in with email and password through the identity provider. On success it stores a session for the client application, records the login and adds the appId to the user when it is missing, then answers the session; the profile fields depend on the profile value. Invalid fields are a 422 with INVALID_REQUEST. Any refusal by the identity provider (wrong password, unknown email, disabled user, too many attempts, any other code) is a 422 whose message is the code. An account that exists at the identity provider but has no profile in the database is a 404 EMAIL_NOT_FOUND, and that dangling provider account is deleted. Any other failure is a 500.')
    .pipe(openapi_1.Security.Public, openapi_1.Error.withV1PublicErrors);
const refreshToken = platform_1.HttpApiEndpoint.put('refreshToken') `/login`
    .setPayload(Auth.RefreshPayload)
    .addSuccess(openapi_1.Response.Success(Auth.RefreshResult))
    .addSuccess(openapi_1.Response.Success(Auth.RefreshWithoutProfileResult))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Refresh Access Token')
    .annotate(platform_1.OpenApi.Description, 'Exchanges a refresh token for a new access token and stores the session for the client application. The answer has no profile fields and no brand. Any failure of the exchange at the identity provider (invalid or expired refresh token, provider unavailable) is a 401 INVALID_CREDENTIALS, never a 422: the handler cannot read the user from the failed result. Invalid fields are a 422 with INVALID_REQUEST. A refresh token whose user has no profile in the database still gets a 200, without userId and roles and with a null tenantId.')
    .pipe(openapi_1.Security.Public, openapi_1.Error.withV1PublicErrors);
const loginWithJwt = platform_1.HttpApiEndpoint.post('loginWithJwt') `/ext/jwt/login`
    .setPayload(Auth.JwtLoginPayload)
    .addSuccess(openapi_1.Response.Success(Auth.LoginResult))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.InvalidTimezone)
    .addError(exports.InvalidJwtEncoding)
    .addError(exports.InvalidJwtContent)
    .addError(exports.TokenExpired)
    .addError(exports.IdentityProviderRejected)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Sign In With JWT')
    .annotate(platform_1.OpenApi.Description, 'Signs a user in with a JWT issued by Apple or Google. Invalid fields are a 422 with INVALID_REQUEST. An unknown timezone is INVALID_TIMEZONE, a token that cannot be decoded is INVALID_JWT_ENCODING, an expired token is TOKEN_EXPIRED, and a token without the expected claims or from an issuer or audience the API does not accept is INVALID_JWT_CONTENT. The email is the email claim, or sub@linked.jwt.local when the token has none. When no user matches that email an account is created with the names from the request, then from the token, then "anonymous" and "user". An email that belongs to an account registered with a password cannot sign in this way: the answer is a 422. A refusal by the identity provider is a 422 with the provider code, and an account without a profile is a 404 USER_PROFILE_NOT_FOUND (unlike the password login there is no EMAIL_NOT_FOUND remap). Any other failure is a 500.')
    .pipe(openapi_1.Security.Public, openapi_1.Error.withV1PublicErrors);
const getApplePass = platform_1.HttpApiEndpoint.get('getApplePass') `/ext/pass/apple`
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .annotate(platform_1.OpenApi.Title, 'Get Apple Wallet Pass')
    .annotate(platform_1.OpenApi.Description, 'Builds the loyalty pass of the signed-in user, signed for Apple Wallet, and sends it as a .pkpass file. Each call also saves the pass record of the user. A failure to build the pass is a 500 with a JSON body. When the pass is built but cannot be turned into a stream, the error is only logged and the answer is a 200 with the same headers and an empty body.')
    .pipe(openapi_1.Response.download({
    contentType: 'application/vnd.apple.pkpass',
    filename: 'culligan-hydropass.pkpass',
}), openapi_1.Error.withV1StandardErrors);
const getGooglePass = platform_1.HttpApiEndpoint.get('getGooglePass') `/ext/pass/google`
    .addSuccess(openapi_1.Response.Success(Auth.GooglePass))
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .annotate(platform_1.OpenApi.Title, 'Get Google Wallet Pass')
    .annotate(platform_1.OpenApi.Description, 'Returns a link that adds the loyalty pass of the signed-in user to Google Wallet. When Google has no pass for the user yet, it is created with the current number of saved bottles. The pass record of the user is saved on every call. Any failure, whether at Google or in the database, is a 500.')
    .pipe(openapi_1.Error.withV1StandardErrors);
const syncGooglePass = platform_1.HttpApiEndpoint.get('syncGooglePass') `/ext/pass/google/sync`
    .addSuccess(openapi_1.Response.Success(Auth.GoogleLoyaltyObject))
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .annotate(platform_1.OpenApi.Title, 'Sync Google Wallet Pass')
    .annotate(platform_1.OpenApi.Description, 'Updates the Google Wallet pass of the signed-in user with the current number of saved bottles and answers the object Google returns. The pass must already exist: a user without one gets a 500. Any other failure is a 500 too. The next-level counter is written from a field the loyalty service does not return, so secondaryLoyaltyPoints.balance.string becomes "undefined bottles" after a sync.')
    .pipe(openapi_1.Error.withV1StandardErrors);
/** An endpoint with no addSuccess still documents a 204; this route has no success answer. */
const withoutSuccess = openapi_1.Annotations.transformOperation(operation => {
    const { '204': _noContent, ...responses } = (operation['responses'] ?? {});
    return { ...operation, responses };
});
const applePassSyncDescription = 'PassKit web-service dispatcher. On the Express runtime the route matches only the exact path, so the handler answers 400; PassKit sub-paths are not routed. The handler also has branches for the PassKit log, pass and device calls and a 501 for other combinations, but none of them can be reached. On production every call that passes authentication is a 403.';
const getApplePassSync = platform_1.HttpApiEndpoint.get('getApplePassSync') `/ext/pass/apple/sync`
    .addError(exports.BadRequest)
    .middleware(openapi_1.Security.V1ApplePassService)
    .annotate(platform_1.OpenApi.Title, 'Apple Pass Sync (GET)')
    .annotate(platform_1.OpenApi.Description, applePassSyncDescription)
    .pipe(withoutSuccess, openapi_1.Error.withV1StandardErrors);
const postApplePassSync = platform_1.HttpApiEndpoint.post('postApplePassSync') `/ext/pass/apple/sync`
    .addError(exports.BadRequest)
    .middleware(openapi_1.Security.V1ApplePassService)
    .annotate(platform_1.OpenApi.Title, 'Apple Pass Sync (POST)')
    .annotate(platform_1.OpenApi.Description, applePassSyncDescription)
    .pipe(withoutSuccess, openapi_1.Error.withV1StandardErrors);
const deleteApplePassSync = platform_1.HttpApiEndpoint.del('deleteApplePassSync') `/ext/pass/apple/sync`
    .addError(exports.BadRequest)
    .middleware(openapi_1.Security.V1ApplePassService)
    .annotate(platform_1.OpenApi.Title, 'Apple Pass Sync (DELETE)')
    .annotate(platform_1.OpenApi.Description, applePassSyncDescription)
    .pipe(withoutSuccess, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.frontend.auth')
    .add(verifyToken)
    .add(login)
    .add(refreshToken)
    .add(loginWithJwt)
    .add(getApplePass)
    .add(getGooglePass)
    .add(syncGooglePass)
    .add(getApplePassSync)
    .add(postApplePassSync)
    .add(deleteApplePassSync)
    .prefix('/auth')
    .annotate(platform_1.OpenApi.Title, 'Auth')
    .annotate(platform_1.OpenApi.Description, 'Login, token refresh, external JWT login and wallet pass endpoints for end users')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.User));
//# sourceMappingURL=spec.js.map